"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const syntax_highlighter_1 = __importDefault(require("../syntax-highlighter"));
const styled_components_1 = __importDefault(require("styled-components"));
class BareSource extends React.Component {
    render() {
        // Build in a default renderer when they pass a plain string
        // This is primarily for use with non-editable contexts (notebook-preview)
        // to make rendering much faster (compared to codemirror)
        // Ref: https://github.com/nteract/notebook-preview/issues/20
        if (typeof this.props.children === "string") {
            return (React.createElement(syntax_highlighter_1.default
            // NOTE: To get around styled-components & defaultProps not lining up,
            // this defaults to "text" for us https://github.com/DefinitelyTyped/DefinitelyTyped/issues/29540
            , { 
                // NOTE: To get around styled-components & defaultProps not lining up,
                // this defaults to "text" for us https://github.com/DefinitelyTyped/DefinitelyTyped/issues/29540
                language: this.props.language || "text", className: this.props.className || "input" }, this.props.children));
        }
        // Otherwise assume they have their own editor component
        return React.createElement("div", { className: this.props.className }, this.props.children);
    }
}
BareSource.defaultProps = {
    children: "",
    language: "text",
    className: "input",
    theme: "light"
};
exports.Source = styled_components_1.default(BareSource) ``;
exports.Source.defaultProps = {
    children: "",
    language: "text",
    className: "input",
    theme: "light"
};
exports.Source.displayName = "Source";
